<template>
  <div ref="voteChartNet"></div>
</template>

<script>
import * as d3 from "d3";



export default {
  name: "VoteChartNet",
  data() {
    return {
      nodes: [
      ],
      links: [
      ],
    };
  },
  props: {
    netChartNodes: {
      type: Array,
      default: () => [],
    },
    netChartLinks: {
      type: Array,
      default: () => [],
    },
    windowWidth: {
      type: Number,
      default: 0,
    }
  },
  watch: {
    netChartNodes() {
      this.updateGraph();
    }
  },
  mounted() {
    this.createGraph();
  },
  methods: {
    updateGraph() {      
      console.log('updateGraph!!!');

      let pre_svg = d3
        .select(this.$refs.voteChartNet)
      pre_svg.selectAll("*").remove();

      var width = 0
      if(this.windowWidth <= 767){
        width = (this.windowWidth/13)*12;
      }else{
        width = (this.windowWidth/13)*6;
      }
      const height = 550;

      const svg = d3
        .select(this.$refs.voteChartNet)
        .append("svg")
        .attr("width", width)
        .attr("height", height);

      var simulation
      if(this.windowWidth <= 767){
        simulation = d3
        .forceSimulation(this.netChartNodes)
        .force(
          "link",
          d3.forceLink(this.netChartLinks).id((d) => d.id).distance(function(d){
            var _distance = Math.floor(Math.random() * (200 - 120 + 1)) + 100
            return _distance
          })
        )
        .force("charge", d3.forceManyBody().strength(function(d){
          if((d.group === 1) || (d.group === 2)){
              return -200
            }else{
              return -400
            }
        }))
        .force("center", d3.forceCenter(width / 2, height / 2));
      }else{
        simulation = d3
        .forceSimulation(this.netChartNodes)
        .force(
          "link",
          d3.forceLink(this.netChartLinks).id((d) => d.id).distance(function(d){
            var _distance = Math.floor(Math.random() * (200 - 120 + 1)) + 150
            return _distance
          })
        )
        .force("charge", d3.forceManyBody().strength(function(d){
          if((d.group === 1) || (d.group === 2)){
              return -200
            }else{
              return -400
            }
        }))
        .force("center", d3.forceCenter(width / 2, height / 2));
      }

      

      const link = svg
        .append("g")
        .selectAll("line")
        .data(this.netChartLinks)
        .enter()
        .append("line")
        .attr("stroke-width", function(d){
            return 2
        })
        .attr("stroke", "#aaa");

      
      var nodeCircles
      if(this.windowWidth <= 767){
        nodeCircles = svg
        .append("g")
        .selectAll("circle")
        .data(this.netChartNodes)
        .enter()
        .filter(d => d.group != 3)
        .append("circle")
        .attr("r", function(d){
          if (d.group ===1){
            return 10
          }else{
            return 65
          }
        })
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "#FFFFFF"))
        .attr('stroke', function(d){
          if (d.group === 1){
            return "none"
          }else{
              return "#404040"
          }
        })
        .attr('stroke-width', (d) => (d.group === 1 ? "none" : 2))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );
      }else{
        nodeCircles = svg
        .append("g")
        .selectAll("circle")
        .data(this.netChartNodes)
        .enter()
        .filter(d => d.group != 3)
        .append("circle")
        .attr("r", function(d){
          if (d.group ===1){
            return 10
          }else{
            return 85
          }
        })
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "#FFFFFF"))
        .attr('stroke', function(d){
          if (d.group === 1){
            return "none"
          }else{
              return "#404040"
          }
        })
        .attr('stroke-width', (d) => (d.group === 1 ? "none" : 2))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );
      }
      
      


      var sub_brand_rank = 0

      const sub_brand_color = ['#ff7f0e', '#FF9F4A', '#FF9F4A', '#FFB777', '#FFB777', '#FFC999', '#FFC999', '#FFD6B2', '#FFD6B2', '#FFD6B2']
      const white_c = '#FFFFFF'
      const black_c = '#404040'
      // const black_c = '#7C4698'
      
      
      const nodeRectangles = svg
        .append("g")
        .selectAll("rect")
        .data(this.netChartNodes)
        .enter()
        .filter(d => d.group === 3)
        .append("rect")
        .attr('rx', 5)
        .attr('width', function(d){
          if(d.id.length < 4){
            return d.freq.toLocaleString().length*15
          }else{
            return d.id.length*15
          }
        })
        .attr('height', 35)
        .attr("fill", function(d){
          if(d.negative == 'Y'){
            return white_c
          }else{
            return black_c
          }
        })
        .attr('stroke', function(d){
          return black_c
        })
        .attr('stroke-width', (d) => (d.group === 1 ? "none" : 2))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        )
        ;
      
      
      const label = svg
        .append("g")
        .selectAll("text")
        .data(this.netChartNodes)
        .enter()
        .append("text")
        .attr("dy", (d) => (d.group === 2 ? 0 : 4))
        .attr("text-anchor", "middle")
        .text((d) => (d.gubun === "nothing" ? "" : d.id))
        .attr('fill', function(d){
          if(d.group === 3){
            if(d.negative == 'Y'){
              return black_c
            }else{
              return white_c
            }
          }else{
            return black_c
          }
        })
        .attr("stroke", (d) => (d.group === 3 ? "none" : "#414141"))
        .attr("stroke-width", (d) => (d.group === 3 ? "none" : 0.5))
        .attr("font-size", (d) => (d.group === 2 ? "1.3rem" : "1rem"))
        ;

      const label1 = svg
        .append("g")
        .selectAll("text")
        .data(this.netChartNodes)
        .enter()
        .append("text")
        .attr("dy", (d) => (d.group === 2 ? 0 : 4))
        .attr("text-anchor", "middle")
        .text((d) => (d.gubun === "nothing" ? "" : "연관어"))
        .attr('fill', function(d){
          if(d.group === 3){
            if(d.negative == 'Y'){
              return black_c
            }else{
              return white_c
            }
          }else{
            return black_c
          }
        })
        .attr("stroke", (d) => (d.group === 3 ? "none" : "#414141"))
        .attr("stroke-width", (d) => (d.group === 3 ? "none" : 0.5))
        .attr("font-size", (d) => (d.group === 2 ? "1.3rem" : "1rem"))
        ;

      const label2 = svg
        .append("g")
        .selectAll("text")
        .data(this.netChartNodes)
        .enter()
        .append("text")
        .attr("dy", (d) => (d.group === 2 ? 4 : 4))
        .attr("text-anchor", "middle")
        .text((d) => (d.gubun === "nothing" ? "" : d.freq.toLocaleString()))
        .attr('fill', function(d){
          if(d.group === 3){
            if(d.negative == 'Y'){
              return black_c
            }else{
              return white_c
            }
          }else{
            return black_c
          }
        })
        .attr("font-size", (d) => (d.group === 2 ? "1.3rem" : "1rem"))
        ;


      simulation.on("tick", () => {
        link
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);

        nodeCircles.attr("cx", (d) => d.x).attr("cy", (d) => d.y);


        nodeRectangles.attr("x", function(d){
          if(d.id.length < 4){
            return (d.x-(d.freq.toLocaleString().length*15/2))
          }else{
            return (d.x-(d.id.length*15/2))
          }
        });
        nodeRectangles.attr("y", (d) => (d.y-10));
        
        label
        .attr('x', function(d){
          return d.x
        })
        .attr('y', function(d){
          if(d.group >2){
            return d.y
          }else{
            return d.y-10
          }
        })

        label1
        .attr('x', function(d){
          return d.x
        })
        .attr('y', function(d){
          if(d.group >2){
            return -10
          }else{
            return d.y+10
          }
        })

        label2
        .attr('x', function(d){
          return d.x
        })
        .attr('y', function(d){
          if(d.group >2){
            return d.y+15
          }else{
            return d.y+30
          }
        })


        // label.attr("x", (d) => d.x).attr("y", (d) => d.y);
        // label1.attr("x", (d) => d.x).attr("y", (d) => (d.y+15));
        // label2.attr("x", (d) => d.x).attr("y", (d) => (d.y+30));
        
      });
    },
    createGraph() {
      console.log('createGraph!!!');

      const width = 1000;
      const height = 550;

      const svg = d3
        .select(this.$refs.voteChartNet)
        .append("svg")
        .attr("width", width)
        .attr("height", height);

      const simulation = d3
        .forceSimulation(this.nodes)
        .force(
          "link",
          d3.forceLink(this.links).id((d) => d.id).distance(50)
        )
        .force("charge", d3.forceManyBody().strength(-400))
        .force("center", d3.forceCenter(width / 2, height / 2));

      const link = svg
        .append("g")
        .selectAll("line")
        .data(this.links)
        .enter()
        .append("line")
        .attr("stroke-width", 0)
        .attr("stroke", "#aaa");

      const nodeCircles = svg
        .append("g")
        .selectAll("circle")
        .data(this.nodes)
        .enter()
        .filter(d => d.group != 3)
        .append("circle")
        .attr("r", 20)
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "none"))
        .attr('stroke', (d) => (d.group === 1 ? "none" : "#ff7f0e"))
        .attr('stroke-width', (d) => (d.group === 1 ? "none" : 2))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );

      const nodeRectangles = svg
        .append("g")
        .selectAll("rect")
        .data(this.nodes)
        .enter()
        .filter(d => d.group === 3)
        .append("rect")
        .attr('width', 40)
        .attr('height', 40)
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "#1f77b4"))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );

      
      
      const label = svg
        .append("g")
        .selectAll("text")
        .data(this.nodes)
        .enter()
        .append("text")
        .attr("dy", 4)
        .attr("text-anchor", "middle")
        .text((d) => d.id);

      simulation.on("tick", () => {
        link
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);
        nodeCircles.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
        nodeRectangles.attr("x", (d) => d.x).attr("y", (d) => d.y).attr('transform', 'translate(-10, -7)');

        label.attr("x", (d) => d.x).attr("y", (d) => d.y);
      });
    },
  },
};
</script>

<style scoped>
/* SVG 스타일링을 위해 CSS 추가 */
svg {
  background: #CFCFCF;
}
</style>
